{
    "2lvXR": {
        "position": {
            "x": 8,
            "y": 7,
            "z": 1
        },
        "key": "2lvXR",
        "tag": "goodspawn"
    },
    "wdBwZ": {
        "position": {
            "x": 7,
            "y": 7,
            "z": 1
        },
        "key": "wdBwZ",
        "tag": "goodspawn"
    },
    "6VW8j": {
        "position": {
            "x": 9,
            "y": 7,
            "z": 1
        },
        "key": "6VW8j",
        "tag": "goodspawn"
    }
}